import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

export interface VendorReportsParams {
  timeRange: "today" | "7_days" | "30_days" | "90_days" | "1_year";
  productType: "all" | "products" | "services";
}

// Raw order item from backend - no conversion done by backend
export interface OrderItem {
  bv: number;
  sellerShareUnit: number;
  sellerShareCurrency: "IRT" | "USDT" | "UVM";
  sellerSettlementCurrency: "USDT" | "UVM";
  createdAt: string;
}

export interface VendorReportData {
  summary: {
    totalBV: number; // Total Business Value (always UVM)
    orderCount: number;
    customerCount: number;
  };
  chartData: {
    labels: string[];
    bv: number[]; // BV values per period (UVM)
  };
  // Raw order items - frontend does all conversion
  orderItems: OrderItem[];
}

interface UseFetchVendorReportsOptions {
  enabled?: boolean;
}

export const useFetchVendorReports = (
  params: VendorReportsParams,
  options: UseFetchVendorReportsOptions = {},
) => {
  const { enabled = true } = options;

  const queryFn = async () => {
    const response = await fetchClient.GET("/vendor/reports", {
      params: {
        query: {
          timeRange: params.timeRange,
          productType: params.productType,
        },
      },
    });

    if (response.error) throw response.error;
    return response.data;
  };

  const { data, error, isLoading, refetch, isFetching } = useQuery({
    queryKey: ["vendor", "reports", params.timeRange, params.productType],
    queryFn,
    enabled,
  });

  return {
    data,
    error,
    isLoading,
    isFetching,
    refetch,
  };
};
